module.exports = __webpack_public_path__ + "img/interface OneB Clock-server_1.d3263844.jpg";